import React, {useState} from "react";
import {connect} from "react-redux";
import {
  CurrencyCreateRoute,
  CurrencyEditRoute
} from "../../routesConstants";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import {Link} from "react-router-dom";
import DataTable from "../../../components/dataTable";
import { Tab, Tabs, Col, Row } from "react-bootstrap";
import Process from "../../../components/process";
import PortletHeaderSearch from "../../base/components/forms/portlerHeaderSearch";
import {Helmet} from "react-helmet";

const CurrencyList = (props)=>{
  const columns = [
    {
      Header: 'Название',
      accessor: 'name',
      Cell: ({value, row}) => <Link to={CurrencyEditRoute + row.original.id } >{value}</Link>
    },
    {
      Header: 'Код',
      accessor: 'code',
    },
    {
      Header: "Действия",
      Cell: ({value, row}) => (<Link className={"btn btn-sm btn-clean btn-icon btn-icon-md"} to={CurrencyEditRoute + row.original.id}><i className={"la la-edit"}/></Link>)
    }
  ]
  const [query, setQuery] = useState("");
  const [tabIndex, setTabIndex] = useState("home");
  return <>
      <Helmet>
        <title>Валюты</title>
      </Helmet>
    <Tabs
      variant="pills"
      id="controlled-tab-example"
      activeKey={tabIndex}
      onSelect={key => setTabIndex(key)}
    >
      <Tab eventKey="home" title="Список">
        <div className={"kt-grid__item"}>
          <Portlet>
            <PortletHeader
              title={"Список валют"}
              toolbar={
                <PortletHeaderToolbar>
                  <PortletHeaderSearch value={query} cb={(v)=>{setQuery(v)}}/>
                  <Link to={CurrencyCreateRoute} className="btn btn-sm btn-brand btn-elevate btn-icon-sm">
                    <i className="la la-plus"/>
                    Добавить
                  </Link>
                </PortletHeaderToolbar>}
            />
            <PortletBody>

              <DataTable columns={columns} search={query} url={`/api/currencies`}/>
            </PortletBody>
          </Portlet>
        </div>
      </Tab>
      <Tab eventKey="profile" title="Действия"  className="tab-no-background">
        <Row>
          <Col md={6}>
            <Process desc={<a href={"http://www.nationalbank.kz"}>http://www.nationalbank.kz/</a>}
                     title={"Синхронизация валют"}
                     link={"/api/currencies/sync"}
                      />
          </Col>
        </Row>

      </Tab>
    </Tabs>

  </>
}


export default connect(null)(CurrencyList)
